'use strict';

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })(); /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                        * @author Sean sean.snow@live.com
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                        * @date 2015/12/25
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                        */

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Long = require('../lang/Long');

var _Long2 = _interopRequireDefault(_Long);

var _StringBuilder = require('../lang/StringBuilder');

var _StringBuilder2 = _interopRequireDefault(_StringBuilder);

var _Arrays = require('./Arrays');

var _Arrays2 = _interopRequireDefault(_Arrays);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ADDRESS_BITS_PER_WORD = 5;
var BITS_PER_WORD = 1 << ADDRESS_BITS_PER_WORD;
var WORD_MASK = 0xffffffffffffffff;

var BitSet = (function () {
    function BitSet(nbits) {
        _classCallCheck(this, BitSet);

        this.words = [];
        this.sizeIsSticky = false;
        this.wordsInUse = 0;

        if (nbits < 0) {
            throw Error('nbits < 0: ' + nbits);
        }
        this._initWords(nbits);
        this.sizeIsSticky = true;
    }

    _createClass(BitSet, [{
        key: 'set',
        value: function set(bitIndex) {
            if (bitIndex < 0) {
                throw Error('bitIndex < 0: ' + bitIndex);
            }

            var wordIndex = this._wordIndex(bitIndex);
            this._expandTo(wordIndex);
            this.words[wordIndex] |= 1 << bitIndex;
        }
    }, {
        key: 'get',
        value: function get(bitIndex) {
            if (bitIndex < 0) {
                throw Error('bitIndex < 0: ' + bitIndex);
            }

            var wordIndex = this._wordIndex(bitIndex);
            return wordIndex < this.wordsInUse && (this.words[wordIndex] & 1 << bitIndex) != 0;
        }
    }, {
        key: 'length',
        value: function length() {
            if (this.wordsInUse === 0) {
                return 0;
            }

            return BITS_PER_WORD * (this.wordsInUse - 1) + (BITS_PER_WORD - _Long2.default.numberOfLeadingZeros(this.words[this.wordsInUse - 1]));
        }
    }, {
        key: 'size',
        value: function size() {
            return this.words.length * BITS_PER_WORD;
        }
    }, {
        key: 'cardinality',
        value: function cardinality() {
            var sum = 0;
            for (var i = 0; i < this.wordsInUse; i++) {
                sum += _Long2.default.bitCount(this.words[i]);
            }
            return sum;
        }
    }, {
        key: 'nextSetBit',
        value: function nextSetBit(fromIndex) {
            if (fromIndex < 0) {
                throw Error('Index Out Of Bounds Exception. fromIndex < 0: ' + fromIndex);
            }

            var u = this._wordIndex(fromIndex);
            if (u >= this.wordsInUse) {
                return -1;
            }

            var word = this.words[u] & WORD_MASK << fromIndex;
            while (true) {
                if (word != 0) {
                    return u * BITS_PER_WORD + _Long2.default.numberOfLeadingZeros(word);
                }
                if (++u === this.wordsInUse) {
                    return -1;
                }
                word = this.words[u];
            }
        }
    }, {
        key: 'nextClearBit',
        value: function nextClearBit(fromIndex) {
            if (fromIndex < 0) {
                throw Error('Index Out Of Bounds Exception. fromIndex < 0: ' + fromIndex);
            }
            var u = this._wordIndex(fromIndex);
            if (u >= this.wordsInUse) return fromIndex;

            var word = ~this.words[u] & WORD_MASK << fromIndex;

            while (true) {
                if (word != 0) return u * BITS_PER_WORD + _Long2.default.numberOfTrailingZeros(word);
                if (++u == this.wordsInUse) return this.wordsInUse * BITS_PER_WORD;
                word = ~this.words[u];
            }
        }
    }, {
        key: '_initWords',
        value: function _initWords(nbits) {
            this.words = new Array(this._wordIndex(nbits - 1) + 1);
        }
    }, {
        key: '_wordIndex',
        value: function _wordIndex(bitIndex) {
            return bitIndex >> ADDRESS_BITS_PER_WORD;
        }
    }, {
        key: '_expandTo',
        value: function _expandTo(wordIndex) {
            var wordsRequired = wordIndex + 1;
            if (this.wordsInUse < wordsRequired) {
                this._ensureCapacity(wordsRequired);
                this.wordsInUse = wordsRequired;
            }
        }
    }, {
        key: '_ensureCapacity',
        value: function _ensureCapacity(wordsRequired) {
            if (this.words.length < wordsRequired) {
                // Allocate larger of doubled size or required size
                var request = Math.max(2 * this.words.length, wordsRequired);
                this.words = _Arrays2.default.copyOf(this.words, request);
                this.sizeIsSticky = false;
            }
        }
    }, {
        key: 'toString',
        value: function toString() {
            var numBits = this.wordsInUse > 128 ? this.cardinality() : this.wordsInUse * BITS_PER_WORD;
            var b = new _StringBuilder2.default(6 * numBits + 2);
            b.append('{');
            var i = this.nextSetBit(0);
            if (i !== -1) {
                b.append(i);
                while (true) {
                    if (++i < 0) break;
                    if ((i = this.nextSetBit(i)) < 0) break;
                    var endOfRun = this.nextClearBit(i);
                    do {
                        b.append(", ").append(i);
                    } while (++i != endOfRun);
                }
            }

            b.append('}');

            return b.toString();
        }
    }]);

    return BitSet;
})();

exports.default = BitSet;


//////////////////
// WEBPACK FOOTER
// ./node_modules/jsdk/util/BitSet.js
// module id = 17
// module chunks = 0